import { ServiceData } from "../../../lib/useServiceData"
import SliderDataBox from "./SliderDataBox"
import { useTranslation } from 'react-i18next';

export default function MainSlideUnit() {
    const { i18n } = useTranslation();
    return (
        <div className="carousel-inner">
            {ServiceData.map((service, index) => (
                <div key={index} className={index === 0 ? "carousel-item active" : "carousel-item"}>
                    <SliderDataBox
                        title={i18n.language === "ar" ? service.title : service.titleEn}
                        description={i18n.language === "ar" ? service.description : service.descriptionEn}
                        btnLink={service.btnLink}
                        btnCaption={i18n.language === "ar" ? service.btnCaption : service.btnCaptionEn}
                        imgSrc={service.imgSrc}
                        imgAlt={service.imgAlt}
                    />
                </div>
            ))}
        </div>
    )
};